import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpService } from './http.service';
import { HttpResponse } from '@angular/common/http';

interface UserCreds {
  email: string;
  password: string;
}

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  constructor(private apiService: HttpService) {}

  signIn = (data: UserCreds): Observable<any> => {
    return this.apiService.postData(`Authenticate/Login`, data);
  };

  changePassword = (data: Partial<{ newPassword: string }>): Observable<any> => {
    return this.apiService.postData(`Authenticate/ChangePassword`, data);
  };

  forgotPassword = (data: Partial<{ email: string }>): Observable<any> => {
    return this.apiService.postData(`Authenticate/ForgotPasswordUpdate`, data);
  };
}
